export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
